import { Component, input, inject, computed } from '@angular/core';
import { ISection, IDocumentType } from '../../../../core/models/documents.model';
import { StateService } from '../../../../core/services/state.service';

@Component({
    selector: 'app-main-personal',
    imports: [],
    templateUrl: './main-personal.html',
    styleUrl: './main-personal.scss',
})
export class MainPersonal {
    sectionsRows = input.required<ISection[][]>();
    children = input.required<IDocumentType[]>();
    sidebarSectionInput = input<ISection | null>(null, { alias: 'sidebarSection' });

    private stateService = inject(StateService);
    readonly sidebarSection = computed(() => this.sidebarSectionInput() || this.stateService.sidebarSection());

    parseFaq(content: any): any[] {
        if (!content) return [];
        if (Array.isArray(content)) return content;
        try {
            let parsed = typeof content === 'string' ? JSON.parse(content) : content;
            if (typeof parsed === 'string') {
                parsed = JSON.parse(parsed);
            }
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            console.error('Error parsing FAQ content:', e);
            return [];
        }
    }
}
